/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {FolderShareProps} from '../FolderShared';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Folder Shared Icon component.
 */
const FolderShared = ({folderColor}: FolderShareProps) => {
  const {iconColor} = useIconDLS({color: folderColor});

  return (
    <svg key={folderColor} width='20' height='17' viewBox='0 0 20 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M2.75 0.75H6.75L9.75 3.75H16.75C17.2804 3.75 17.7891 3.96071 18.1642 4.33579C18.5393 4.71086 18.75 5.21957 18.75 5.75V13.75C18.75 14.2804 18.5393 14.7891 18.1642 15.1642C17.7891 15.5393 17.2804 15.75 16.75 15.75H2.75C2.21957 15.75 1.71086 15.5393 1.33579 15.1642C0.960714 14.7891 0.75 14.2804 0.75 13.75V2.75C0.75 2.21957 0.960714 1.71086 1.33579 1.33579C1.71086 0.960714 2.21957 0.75 2.75 0.75Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default React.memo(FolderShared);
